import { isEmpty, difference } from 'ramda';
import { getHandler, patchHandler } from 'src/utils/fetchHandler';
import { getFundraiserIdsFetching } from './fundraiser.selector';

export const CLEAR_USER_FUNDRAISER = 'CLEAR_USER_FUNDRAISER/FUNDRAISER/@WISELY/WEB';
export const GET_USER_FUNDRAISER = 'GET_USER_FUNDRAISER/FUNDRAISER/@WISELY/WEB';
export const FETCH_USER_FUNDRAISER_SUCCEEDED =
	'FETCH_USER_FUNDRAISER_SUCCEEDED/FUNDRAISER/@WISELY/WEB';
export const FETCH_USER_FUNDRAISER_FAILED = 'FETCH_USER_FUNDRAISER_FAILED/FUNDRAISER/@WISELY/WEB';

export const CLEAR_FUNDRAISERS = 'CLEAR_FUNDRAISERS/FUNDRAISERS/@WISELY/WEB';
export const GET_FUNDRAISERS = 'GET_FUNDRAISERS/FUNDRAISERS/@WISELY/WEB';
export const GET_FUNDRAISER = 'GET_FUNDRAISER/FUNDRAISERS/@WISELY/WEB';
export const FETCH_FUNDRAISERS_SUCCEEDED = 'FETCH_FUNDRAISERS_SUCCEEDED/FUNDRAISERS/@WISELY/WEB';
export const FETCH_FUNDRAISERS_FAILED = 'FETCH_FUNDRAISERS_FAILED/FUNDRAISERS/@WISELY/WEB';
export const FETCH_FUNDRAISER_SUCCEEDED = 'FETCH_FUNDRAISER_SUCCEEDED/FUNDRAISERS/@WISELY/WEB';
export const FETCH_FUNDRAISER_FAILED = 'FETCH_FUNDRAISER_FAILED/FUNDRAISERS/@WISELY/WEB';

export const UPDATE_FUNDRAISER = 'UPDATE_FUNDRAISER/FUNDRAISERS/@WISELY/WEB';
export const UPDATE_FUNDRAISER_SUCCEEDED = 'UPDATE_FUNDRAISER_SUCCEEDED/FUNDRAISERS/@WISELY/WEB';
export const UPDATE_FUNDRAISER_FAILED = 'UPDATE_FUNDRAISER_FAILED/FUNDRAISERS/@WISELY/WEB';

export const UPDATE_USER_FUNDRAISER = 'UPDATE_USER_FUNDRAISER/FUNDRAISERS/@WISELY/WEB';
export const UPDATE_USER_FUNDRAISER_SUCCEEDED =
	'UPDATE_USER_FUNDRAISER_SUCCEEDED/FUNDRAISERS/@WISELY/WEB';
export const UPDATE_USER_FUNDRAISER_FAILED =
	'UPDATE_USER_FUNDRAISER_FAILED/FUNDRAISERS/@WISELY/WEB';

export const getUserFundraiser = () => ({
	type: GET_USER_FUNDRAISER,
});

export const fetchUserFundraiserSucceeded = obj => ({
	type: FETCH_USER_FUNDRAISER_SUCCEEDED,
	payload: obj,
});

export const fetchUserFundraiserFailed = () => ({
	type: FETCH_USER_FUNDRAISER_FAILED,
});

export const fetchUserFundraiser = params => {
	return dispatch => {
		dispatch(getUserFundraiser());
		const path = 'v2/fundraisers/me';

		return getHandler(path, params)
			.then(json => dispatch(fetchUserFundraiserSucceeded(json)))
			.catch(error => {
				console.error('fetchUserFundraiser error', error);
				dispatch(fetchUserFundraiserFailed());
			});
	};
};

export const clearFundraisers = () => ({
	type: CLEAR_FUNDRAISERS,
});

export const getFundraisers = ids => ({
	type: GET_FUNDRAISERS,
	payload: ids,
});

export const getFundraiser = () => ({
	type: GET_FUNDRAISER,
});

export const fetchFundraisersSucceeded = list => ({
	type: FETCH_FUNDRAISERS_SUCCEEDED,
	payload: list,
});

export const fetchFundraisersFailed = () => ({
	type: FETCH_FUNDRAISERS_FAILED,
});

export const fetchFundraisersByIds = ids => {
	return (dispatch, getState) => {
		// getState() is specifically for when we trigger many similar fetches within the same JS event loop tick,
		// before the state updates can be propagated to the requesting components
		const idsCurrentlyBeingFetched = getFundraiserIdsFetching(getState());
		const idsRequestedNotBeingFetched = difference(ids, idsCurrentlyBeingFetched);

		if (isEmpty(idsRequestedNotBeingFetched)) {
			return null;
		}

		dispatch(getFundraisers(idsRequestedNotBeingFetched));
		const path = 'v2/fundraisers';

		return getHandler(path, { _id: idsRequestedNotBeingFetched })
			.then(json => dispatch(fetchFundraisersSucceeded(json)))
			.catch(error => {
				console.error('fetchFundraisersByIds error', error);
				dispatch(fetchFundraisersFailed());
			});
	};
};

export const fetchFundraiserSucceeded = payload => ({
	type: FETCH_FUNDRAISER_SUCCEEDED,
	payload,
});

export const fetchFundraiserFailed = () => ({
	type: FETCH_FUNDRAISER_FAILED,
});

export const fetchFundraiser = (id, params) => {
	return dispatch => {
		if (!isEmpty(id)) {
			dispatch(getFundraiser());
			const path = `v2/fundraisers/${id}`;

			return getHandler(path, params)
				.then(json => dispatch(fetchFundraiserSucceeded(json)))
				.catch(error => {
					console.error('fetchFundraiser error', error);
					dispatch(fetchFundraiserFailed());
				});
		}
	};
};

export const updateFundraiser = () => ({
	type: UPDATE_FUNDRAISER,
});

export const requestUpdateFundraiserSucceeded = payload => ({
	type: UPDATE_FUNDRAISER_SUCCEEDED,
	payload,
});

export const requestUpdateFundraiserFailed = payload => ({
	type: UPDATE_FUNDRAISER_FAILED,
	payload,
});

export const requestUpdateFundraiser = (id, body) => {
	return async dispatch => {
		dispatch(updateFundraiser());
		const path = `v2/fundraisers/${id}`;

		return patchHandler(path, JSON.stringify(body))
			.then(json => dispatch(requestUpdateFundraiserSucceeded(json)))
			.catch(error => {
				console.error('requestUpdateFundraiser error', error);
				dispatch(requestUpdateFundraiserFailed(error));
			});
	};
};

export const updateUserFundraiser = () => ({
	type: UPDATE_USER_FUNDRAISER,
});

export const requestUpdateUserFundraiserSucceeded = payload => ({
	type: UPDATE_USER_FUNDRAISER_SUCCEEDED,
	payload,
});

export const requestUpdateUserFundraiserFailed = payload => ({
	type: UPDATE_USER_FUNDRAISER_FAILED,
	payload,
});

export const requestUpdateUserFundraiser = (id, body) => {
	return async dispatch => {
		dispatch(updateUserFundraiser());
		const path = `v2/fundraisers/${id}`;

		return patchHandler(path, JSON.stringify(body))
			.then(json => dispatch(requestUpdateUserFundraiserSucceeded(json)))
			.catch(error => {
				console.error('requestUpdateUserFundraiser error', error);
				dispatch(requestUpdateUserFundraiserFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/fundraisers/fundraiser.action.js